import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  change(event) {
    const frame = document.getElementById('file');
    frame.src = 'feed/' + event.target.value;
    frame.reload();
  }
}
